const Footer = () => {
  return (
    <>
      <p>IT DRAFT CLM</p>
      Copyright ©2026
    </>
  );
};

export default Footer;
